import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'

import { getStuSwitchInfo, recordStopInfo } from '@/api/room'
import bear_img from '@/assets/images/rest/bear.png'
import close_img from '@/assets/images/rest/close.png'
import in_rest_img from '@/assets/images/rest/in-rest.png'
import in_rest_bg_img from '@/assets/images/rest/in-rest-bg.png'
import line_img from '@/assets/images/rest/line.png'
import look_img from '@/assets/images/rest/look.png'
import over_img from '@/assets/images/rest/over.png'
import rest_now_img from '@/assets/images/rest/rest-now.png'
import rest_num_bg_img from '@/assets/images/rest/rest-num-bg.png'
import screenshot_img from '@/assets/images/rest/screenshot.png'
import screenshot_tips_img from '@/assets/images/rest/screenshot-tips.png'
import timeout_max_bg_img from '@/assets/images/rest/timeout-max-bg.png'
import timeout_min_img from '@/assets/images/rest/timeout-min.png'
import attendClassAudio from '@/assets/mp3/attendClass.mp3'
import inRestAudio from '@/assets/mp3/in-rest.mp3'
import Loadding from '@/components/Loadding'
import { roomEvent, rtcClient, rtmClient } from '@/pages/room'
import { autoplayState, coursewareListState, penStateState, viewPicIdIndexState, viewPicIdState } from '@/store/courseware'
import { bigWinState, breadInClassInfoState, paramsState, restState, roomReadyState, syncStateState, useDeviceState } from '@/store/room'
import uploadClient from '@/utils/upload-client'

import { coursewareBoard } from '../Courseware'
import { position } from '../Video'

const timeNum = 600

export default function Index() {
  const restAudioRef = useRef<HTMLAudioElement>(null)
  const clickAudio = useRef<HTMLAudioElement>(null)
  // 准备进入休息倒计时
  const [startTimeClock, setStartTimeClock] = useState(59)
  // 准备进入休息状态
  const [startTimeClockState, setStartTimeClockState] = useState(false)
  const [screenshotState, setScreenshotState] = useState(false)
  const [screenshotSuccess, setScreenshotSuccess] = useState(false)
  const [loading, setLoading] = useState(false)
  // 是否请求服务端课间休息开启状态 normal loading pass reject
  const serveRestState = useRef<'normal' | 'loading' | 'pass' | 'reject'>('normal')
  // 是否播放过进入课间休息的音频
  const isPlayInRestAudio = useRef(false)
  const [breadInClassInfo, setBreadInClassInfo] = useRecoilState(breadInClassInfoState)
  const [rest, setRest] = useRecoilState(restState)
  const localRestState = useRef<number>(rest.state)
  const localStartTime = useRef<number>(0)
  const [params, setParams] = useRecoilState(paramsState)
  const [bigWin, setBigWin] = useRecoilState(bigWinState)
  const viewPicIdIndex = useRecoilValue(viewPicIdIndexState)
  const [syncState, setSyncState] = useRecoilState(syncStateState)
  const [useDevice, setUseDevice] = useRecoilState(useDeviceState)
  const [coursewareList, setCoursewareList] = useRecoilState(coursewareListState)
  const [viewPicId, setViewPicId] = useRecoilState(viewPicIdState)
  const roomReady = useRecoilValue(roomReadyState)
  const [autoplay, setAutoplay] = useRecoilState(autoplayState)
  const penState = useRecoilValue(penStateState)

  useEffect(() => {
    if (roomReady) {
      console.log('「Rest」数据,breadInClassInfo:', breadInClassInfo, ',rest:', rest)
      roomEvent.on('roomTime', dot)
      rtmClient.on('ArtClassRestStart', ArtClassRestStart)
      rtmClient.on('ArtClassRestEnd', ArtClassRestEnd)
    }
    return () => {
      roomEvent.removeListener('roomTime', dot)
      rtmClient.removeListener('ArtClassRestStart', ArtClassRestStart)
      rtmClient.removeListener('ArtClassRestEnd', ArtClassRestEnd)
    }
  }, [roomReady])

  const ArtClassRestStart = useCallback((memberId: string, payload: any) => {
    console.log('ArtClassRestStart', payload)
    const { restCutImage, startRestTime, currentIndex = 1 } = payload
    localStartTime.current = startRestTime
    setRest((v) => ({ ...v, state: 1, teaPic: restCutImage, restCoursePicId: restCutImage.split('/').slice(-1)[0].split('.')[0] }))
  }, [])

  const ArtClassRestEnd = useCallback((memberId: string, payload: any) => {
    console.log('ArtClassRestEnd', payload)
    setRest((v) => ({ ...v, state: 2 }))
  }, [])

  const dot = useCallback((second: number) => {
    const { picUrl = '', courseIndex = 1, startTime, endTime } = breadInClassInfo
    // 超过35分钟 || 存在结束时间 || 临时教室 直接关闭
    if (second > 2100 || endTime || params.isTempClass || localRestState.current === 2) {
      roomEvent.removeListener('roomTime', dot)
      return
    }

    // 存在开始休息时间，进入休息
    if (startTime) {
      // 已休息时长 = 课程进行时长 - 休息开始时间
      const clockNum = second - startTime
      // 已休息时长 < 休息总时长 就是还能继续休息
      if (clockNum < timeNum) {
        localStartTime.current = startTime
        setRest((v) => ({ ...v, state: 1, teaPic: picUrl, restCoursePicId: picUrl.split('/').slice(-1)[0].split('.')[0] }))
      }
    }
    // 获取服务端状态
    if (localRestState.current === 0 && second >= 1440 && serveRestState.current === 'normal' && !startTime) {
      serveRestState.current = 'loading'
      getStuSwitchInfo({ userId: params.studentId })
        .then((res) => {
          console.log('「Rest」服务端状态', res)
          const { data } = res
          const { switchStatus } = data
          if (switchStatus !== 0) {
            roomEvent.removeListener('roomTime', dot)
            serveRestState.current = 'reject'
          } else {
            serveRestState.current = 'pass'
          }
        })
        .catch(() => {
          serveRestState.current = 'normal'
        })
    }
    // 24~25分钟，准备休息
    if (localRestState.current === 0 && second >= 1440 && second < 1500 && serveRestState.current === 'pass' && !startTime) {
      console.log('「Rest」24~25分钟倒计时', second, clickAudio.current?.paused)
      if (clickAudio.current?.paused && !isPlayInRestAudio.current) {
        // 把透视矫正关了
        // this.changeCorrectState(false)
        console.log('「Rest」play')
        clickAudio.current && (clickAudio.current.src = inRestAudio)
        clickAudio.current?.play()
        isPlayInRestAudio.current = true
      }
      setStartTimeClock(1500 - second)
      setStartTimeClockState(true)
    }
    // 大于等于25分钟，进入休息
    if (localRestState.current === 0 && second >= 1500 && serveRestState.current === 'pass' && !startTime) {
      console.log(`「Rest」大于等于25分钟，进入休息`, second)
      setStartTimeClockState(false)
      localStartTime.current = 1500
      setRest((v) => ({ ...v, state: 1 }))
    }
    // 休息中计时
    if (localRestState.current === 1) {
      const clockNum = timeNum - (second - localStartTime.current)
      setRest((v) => {
        const newRest = { ...v }
        newRest.clockNum = clockNum
        if (newRest.clockNum === 0) {
          newRest.state = 2
        }
        if (newRest.clockNum <= 30) {
          newRest.attendClassState = true
        }
        // console.log(`「Rest」休息中计时`, second, newRest)
        return { ...newRest }
      })
    }
  }, [])

  // 开始或结束休息状态
  useEffect(() => {
    localRestState.current = rest.state
    if (rest.state === 1) {
      start()
    } else if (rest.state === 2) {
      end()
    }
  }, [rest.state])

  // 打开截图 - 画纸窗口大屏
  useEffect(() => {
    if (screenshotState) {
      setBigWin(useDevice.viceCamera ? 3 : 2)
    }
  }, [screenshotState])

  // 24分钟到25分钟，老师截图阶段 - 打开截图
  const setScreenshot = (state: boolean) => {
    if (state) {
      setRest((v) => ({ ...v, onceRest: true }))
    } else {
      const screenshotBoxDom = document.querySelector('#screenshot-box') as Element
      screenshotBoxDom.innerHTML = ''
      setScreenshotSuccess(false)
      setRest((v) => ({ ...v, onceRest: false }))
    }
    setScreenshotState(state)
  }

  // 截图 || 开始休息
  const screenshotOrStart = () => {
    if (screenshotSuccess) {
      console.log(`「Rest」手动开始休息`, 1500 - startTimeClock)
      setStartTimeClockState(false)
      localStartTime.current = 1500 - startTimeClock
      setRest((v) => ({ ...v, state: 1, onceRest: false }))
      setLoading(false)
    } else {
      console.log(`「Rest」正在截图`)
      const scale = 1
      const screenshotBoxDom = document.querySelector('#screenshot-box')
      const videoMainDom = document.querySelector(`#video_${useDevice.viceCamera ? 'viceTeacher' : 'mainTeacher'}`) as Element
      const videoDom = videoMainDom.querySelector('video') as HTMLVideoElement
      const canvas = document.createElement('canvas')
      const context: any = canvas.getContext('2d')
      canvas.width = videoDom.videoWidth * scale
      canvas.height = videoDom.videoHeight * scale

      // const domId = this.findUserId(this.bigWindowUser.userId)
      // const currentDom = document.querySelector(`#${domId}`) as HTMLElement
      // // 是否连接just
      // const isJust = currentDom.className.includes('just-contain')

      // const { userId } = this.bigWindowUser
      // const option = this.videoConfig[userId] || {}
      // if (!isJust) {
      //   // 由于默认就是镜像，所有对应镜像应反着来
      //   if (option.flip && option.mirror) {
      //     // 镜像+翻转
      //     context.translate(0, videoDom.videoHeight * scale)
      //     context.scale(1, -1)
      //   } else if (option.mirror) {
      //     // 镜像
      //     context.translate(videoDom.videoWidth * scale, 0)
      //     context.scale(-1, 1)
      //   } else if (option.flip) {
      //     // 翻转
      //     context.translate(videoDom.videoWidth * scale, videoDom.videoHeight * scale)
      //     context.scale(-1, 1)
      //     context.scale(1, -1)
      //   }
      // }

      context.drawImage(videoDom, 0, 0, canvas.width, canvas.height)
      const img = document.createElement('img')
      img.style.width = '100%'
      img.style.height = '100%'
      let data = canvas.toDataURL('image/png')
      img.src = data
      screenshotBoxDom?.appendChild(img)
      data = data.split(',')[1]
      data = window.atob(data)
      const ia = new Uint8Array(data.length)
      for (let i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i)
      }
      // 返回 blob 对象
      const blobData = new Blob([ia], {
        type: 'image/png'
      })
      const blobToFile = [new window.File([blobData], 'png', { type: 'image/*' })]
      uploadClient
        .fileUpload(blobToFile)
        .then((result: any) => {
          const { picUrl } = result[0]
          setScreenshotSuccess(true)
          setLoading(false)
          setRest((v) => ({ ...v, teaPic: picUrl, restCoursePicId: picUrl.split('/').slice(-1)[0].split('.')[0] }))
        })
        .catch((err) => {})
        .finally(() => {})
    }
  }

  // 开始休息、调接口、发信令、关闭音视频、插入课件
  const start = async () => {
    console.log('「Rest」开始休息')
    const { startTime, endTime, courseIndex = 1 } = breadInClassInfo
    const { teaPic, restCoursePicId } = rest

    // 关闭老视频弹窗
    roomEvent.emit('rest-state', true)
    setAutoplay(false)
    coursewareBoard.setConf({ tool: 0 })

    // 关闭音视频
    try {
      rtcClient.deviceOff('mainVideo').catch(() => {
        rtcClient.changeMainCamera({ deviceId: '' })
      })
      rtcClient.deviceOff('audio').catch(() => {
        rtcClient.changeMicrophone({ deviceId: '' })
      })
      rtcClient.deviceOff('viceVideo').catch(() => {
        rtcClient.changeViceCamera({ deviceId: '' })
      })
    } catch (error) {
      console.error('关闭音视频失败', error)
    }

    // let courseImageIndex = Math.max(1, courseIndex)
    // if (startTime === 0 && endTime === 0) {
    //   courseImageIndex = viewPicIdIndex + 1
    //   console.log('「Rest」第一次调用开始接口和信令', localStartTime.current, courseImageIndex)
    //   // 调接口
    //   recordStopInfo({
    //     courseIndex: courseImageIndex,
    //     endTime: 0,
    //     lessonTimeId: params.lessonTimeId,
    //     picUrl: teaPic,
    //     roomId: params.roomId,
    //     startTime: localStartTime.current,
    //     teacherId: params.teacherId
    //   })
    //   // 发信令
    //   rtmClient.sendMessage('ArtClassRestStart', {
    //     restCutImage: teaPic,
    //     startRestTime: localStartTime.current,
    //     currentIndex: courseImageIndex
    //   })
    // }
    // // 模式改为课件
    // setSyncState('classPage')
    // // 课件大窗
    // setBigWin(1)
    // // 模式改为课件信令
    // rtmClient.sendMessage('ArtCommandControl', {
    //   cmdType: 12
    // })

    // // 存在截图则插入课件
    // if (teaPic) {
    //   const screenshotPic = {
    //     lines: [],
    //     picId: restCoursePicId,
    //     picUrl: teaPic,
    //     createTime: parseInt(`${new Date().getTime() / 1000}`, 10),
    //     type: 1,
    //     courseType: 1
    //   }
    //   console.log('「Rest」存在截图则插入课件', screenshotPic, courseImageIndex)
    //   const courseware = coursewareList.find((courseware) => courseware.picId === restCoursePicId)
    //   if (!courseware) {
    //     const n = [...coursewareList]
    //     n.splice(courseImageIndex - 1, 0, screenshotPic)
    //     setCoursewareList(n)
    //   }
    //   setViewPicId(restCoursePicId)
    // }
  }

  // 结束休息、调接口、发信令、恢复音视频、删除课件
  const end = async () => {
    console.log('「Rest」结束休息')
    const { clockNum, restCoursePicId } = rest

    // 恢复状态
    roomEvent.emit('rest-state', false)
    !penState && coursewareBoard.setConf({ tool: 1 })
    setAutoplay(true)

    // 恢复音视频 isJust则不开启 TODO
    console.log('「Rest」useDevice', useDevice)
    try {
      // 设置麦克风状态
      if (useDevice.microphone) {
        rtcClient.deviceOn('mainVideo').catch(() => {
          useDevice.mainCamera && rtcClient.changeMainCamera({ deviceId: useDevice.mainCamera, microphoneId: useDevice.microphone })
        })
      } else {
        rtcClient.deviceOn('mainVideo').catch(() => {
          useDevice.mainCamera && rtcClient.changeMainCamera({ deviceId: useDevice.mainCamera })
        })
      }
      rtcClient.deviceOn('viceVideo').catch(() => {
        useDevice.viceCamera && rtcClient.changeViceCamera({ deviceId: useDevice.viceCamera })
      })
    } catch (error) {
      console.error('恢复音视频失败', useDevice.mainCamera, useDevice.microphone, useDevice.viceCamera)
      console.error(error)
    }

    // // 调接口
    // recordStopInfo({
    //   startTime: localStartTime.current,
    //   endTime: localStartTime.current + timeNum - clockNum,
    //   lessonTimeId: params.lessonTimeId,
    //   roomId: params.roomId,
    //   teacherId: params.teacherId
    // })
    // // 发信令
    // rtmClient.sendMessage('ArtClassRestEnd', {
    //   endRestTime: localStartTime.current + timeNum - clockNum,
    //   endRestType: 0 // 0正常结束 1跳过
    // })
    // 删除课件 TODO
    const coursewareIndex = coursewareList.findIndex((courseware) => courseware.picId === restCoursePicId)
    if (coursewareIndex >= 0) {
      const n = [...coursewareList]
      n.splice(coursewareIndex, 1)
      setCoursewareList(n)
      // 移除课间后当前课件存在3中情况
      // 1.被占用的课件 [原课件、截图、原课件]
      // 2.最后一个课件 [原课件、原课件、截图]
      // 3.空 [截图]
      let picId = ''
      if (n[coursewareIndex]) {
        picId = n[coursewareIndex].picId
      } else if (n[coursewareIndex - 1]) {
        picId = n[coursewareIndex - 1].picId
      }
      setViewPicId(picId)
    }
  }

  // 最后30秒播放音频
  useEffect(() => {
    if (rest.attendClassState) {
      clickAudio.current && (clickAudio.current.src = attendClassAudio)
      clickAudio.current?.play()
    }
  }, [rest.attendClassState])

  // 查看课件
  const previewCourse = () => {
    setRest((v) => ({ ...v, previewCourse: true }))
  }

  // 手动结束休息
  const manualClassRestEnd = () => {
    setRest((v) => ({ ...v, state: 2 }))
  }

  // 准备休息60s倒计时
  const fixStartTimeClock = (type = 0) => {
    return type ? `00:${startTimeClock >= 10 ? startTimeClock : `0${startTimeClock}`}` : `${startTimeClock >= 10 ? startTimeClock : `0${startTimeClock}`}`
  }

  // 倒计时大卡
  const easyTime = (i: number) => {
    if (rest.clockNum >= 0) {
      const clockNum = rest.clockNum
      let minute: any = (clockNum - (clockNum % 60)) / 60
      let second: any = clockNum % 60
      minute = minute >= 10 ? `${minute}` : `0${minute}`
      second = second >= 10 ? `${second}` : `0${second}`
      let t = '0'
      switch (i) {
        case 0:
          t = minute[0]
          break
        case 1:
          t = minute[1]
          break
        case 2:
          t = second[0]
          break
        default:
          t = second[1]
          break
      }
      return t
    }
    return '0'
  }

  // 倒计时小卡
  const fixTime = () => {
    if (rest.clockNum >= 0) {
      const clockNum = rest.clockNum
      const minute = (clockNum - (clockNum % 60)) / 60
      const second = clockNum % 60
      return `${minute >= 10 ? minute : `0${minute}`}:${second >= 10 ? second : `0${second}`}`
    }
    return '00:00'
  }

  return (
    <Container
      className={`${position[1]} rest ${rest.state === 1 || startTimeClockState ? '' : 'hidden'} ${
        (!rest.attendClassState && rest.previewCourse) || (startTimeClockState && !screenshotState) ? 'min-rest' : ''
      }`}
    >
      {/* 进入休息卡 */}
      {startTimeClockState && !screenshotState ? (
        <div className="in-rest">
          <div className="in-rest-clock">{fixStartTimeClock(1)}</div>
          {/* <div className="in-rest-btn" onClick={() => setScreenshot(true)}></div> */}
        </div>
      ) : null}
      {/* 截图卡 */}
      <div className={`screenshot ${startTimeClockState && screenshotState ? 'flex' : 'hidden'}`}>
        <Loadding state={loading}>
          <div className={`screenshot-box ${screenshotState ? '' : 'hidden'}`} id="screenshot-box"></div>
        </Loadding>
        <div className="line"></div>
        <div className="screenshot-tips-box">
          <div className={`screenshot-tips ${!screenshotSuccess ? '' : 'hidden'}`}></div>
        </div>
        <div className="close" onClick={() => setScreenshot(false)}></div>
        <div
          className={`screenshot-btn ${screenshotSuccess ? 'screenshot-rest-now' : ''} ${loading ? 'hidden' : ''}`}
          onClick={() => {
            !loading && screenshotOrStart()
          }}
        >
          即将进入课间休息（{fixStartTimeClock(0)}s）
        </div>
      </div>
      {/* 倒计时卡 */}
      {rest.state === 1 && (!rest.previewCourse || rest.attendClassState) ? (
        <div className="timeout-max">
          <div className="timeout-max-clock">
            <div className="bg"></div>
            <div className="title">课间休息</div>
            <div className="clock">
              <div className={`num ${rest.attendClassState ? 'attend-class' : ''}`}>{easyTime(0)}</div>
              <div className={`num ${rest.attendClassState ? 'attend-class' : ''}`}>{easyTime(1)}</div>
              <div className="colon">:</div>
              <div className={`num ${rest.attendClassState ? 'attend-class' : ''}`}>{easyTime(2)}</div>
              <div className={`num ${rest.attendClassState ? 'attend-class' : ''}`}>{easyTime(3)}</div>
            </div>
          </div>
          <div className="timeout-max-beaer"></div>
          {!rest.attendClassState ? <div className="timeout-max-btn" onClick={previewCourse}></div> : null}
        </div>
      ) : null}
      {/* 倒计时小卡 */}
      {rest.state === 1 && rest.previewCourse && !rest.attendClassState ? (
        <div className="timeout-min">
          <div className="timeout-min-clock">{fixTime()}</div>
        </div>
      ) : null}
    </Container>
  )
}

const Container = styled(motion.div)`
  z-index: 99;
  .in-rest {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 26.22vh;
    height: 17.72472vh;
    background-image: url('${timeout_min_img}');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    /* justify-content: center; */
    align-items: center;
    flex-direction: column;
    .in-rest-clock {
      margin-top: 8.66vh;
      font-size: 5vh;
      font-weight: bold;
      line-height: 3.76vh;
      color: white;
    }
    .in-rest-btn {
      cursor: pointer;
      margin-top: 3.76vh;
      width: 19.2vh;
      height: 5.64vh;
      background-image: url('${in_rest_img}');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .screenshot {
    width: 100%;
    height: 100%;
    border: 1vh solid #8fde4d;
    border-radius: 0.4vh;
    /* display: flex; */
    flex-direction: column;
    align-items: center;
    .screenshot-tips-box {
      width: 43.86vh;
      height: 7.32vh;
      margin-top: 7.84vh;
      margin-bottom: auto;
      .screenshot-tips {
        width: 100%;
        height: 100%;
        background-image: url('${screenshot_tips_img}');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .close {
      cursor: pointer;
      width: 9.2vh;
      height: 9.08vh;
      position: absolute;
      top: 0;
      right: -10vh;
      background-image: url('${close_img}');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .screenshot-btn {
      cursor: pointer;
      width: 27.58vh;
      height: 11.8vh;
      border-radius: 5.6vh;
      font-size: 1.88vh;
      line-height: 1.88vh;
      margin-bottom: 5.22vh;
      background-image: url('${screenshot_img}');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding-top: 6.9vh;
      text-align: center;
      font-weight: bold;
      color: white;
    }
    .screenshot-rest-now {
      background-image: url('${rest_now_img}');
    }
    .line {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
      background-image: url('${line_img}');
      background-repeat: repeat;
      background-position: 0 0;
      background-size: 60%;
    }
    .screenshot-box {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: -2;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        object-fit: contain;
      }
    }
  }
  .timeout-max {
    width: 100%;
    height: 100%;
    background-color: #d3fea7;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .timeout-max-clock {
      margin-top: 6.8vh;
      border-radius: 8.36vh;
      border: 2vh solid #8fde4d;
      background-color: #1b8c28;
      width: 80%;
      height: 60vh;
      position: relative;
      color: white;
      .bg {
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        background-image: url('${timeout_max_bg_img}');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .title {
        font-size: 4.8vh;
        line-height: 4.8vh;
        margin-top: 12vh;
        font-weight: bold;
        text-align: center;
      }
      .clock {
        margin-top: 4vh;
        height: 22.24vh;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12.54vh;
        line-height: 12.54vh;
      }
      .num {
        width: 14.84vh;
        height: 22.24vh;
        background-image: url('${rest_num_bg_img}');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin: 0 0.8vh;
        font-size: 12.54vh;
        line-height: 12.54vh;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .attend-class {
        color: #ffd325;
      }
      .colon {
        margin: 0 1vh;
      }
    }
    .timeout-max-beaer {
      width: 23.5vh;
      height: 32.86vh;
      position: absolute;
      bottom: 10vh;
      left: 0;
      background-image: url('${bear_img}');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .timeout-max-btn {
      cursor: pointer;
      margin-top: 6.8vh;
      width: 22.88vh;
      height: 8.36vh;
      background-image: url('${look_img}');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .timeout-max-over {
      cursor: pointer;
      margin-top: 6.8vh;
      width: 22.88vh;
      height: 8.36vh;
      background-image: url('${over_img}');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .timeout-min {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 26.22vh;
    height: 17.72vh;
    background-image: url('${timeout_min_img}');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    /* justify-content: center; */
    align-items: center;
    flex-direction: column;
    .timeout-min-clock {
      margin-top: 8.66vh;
      font-size: 5vh;
      font-weight: bold;
      line-height: 3.76vh;
      color: white;
    }
  }
  &.min-rest {
    top: 73vh;
    width: 26.22vh;
    height: 23vh;
  }
`
